import { render, staticRenderFns } from "./DeleteModal.vue?vue&type=template&id=748828cc&scoped=true&lang=pug&"
import script from "./DeleteModal.vue?vue&type=script&lang=ts&"
export * from "./DeleteModal.vue?vue&type=script&lang=ts&"
import style0 from "./DeleteModal.vue?vue&type=style&index=0&id=748828cc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "748828cc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VDialog,VIcon,VTooltip})
